// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "技术经济学",
      "tec": "马铭婧",
      "week": "1-8周",
      "add": "教学楼D座213经管"
    },
    0,
    0,
    0,
    0
  ],
  "2": [
    0,
    0,
    {
      "sub": "碳资产管理",
      "tec": "王春林",
      "week": "1-12周",
      "add": "教学楼D座213经管"
    },
    {
      "sub": "能源法律法规",
      "tec": "王春林",
      "week": "1-12周",
      "add": "教学楼D座213经管"
    },
    0
  ],
  "3": [
    {
      "sub": "技术经济学",
      "tec": "马铭婧",
      "week": "1-8周",
      "add": "教学楼D座213经管"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "碳资产管理",
      "tec": "王春林",
      "week": "1-12周",
      "add": "教学楼D座213经管"
    },
    {
      "sub": "能源法律法规",
      "tec": "王春林",
      "week": "1,3,7,9周",
      "add": "教学楼D座324经管"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "能源战略与安全",
      "tec": "吕阳",
      "week": "1-4,6-9周",
      "add": "教学楼D座213经管"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
